import { Injectable } from "@angular/core";

/** True when running inside the native iOS/Android shell (Capacitor). */
export function isNativePlatform(): boolean {
  const cap = (globalThis as { Capacitor?: { isNativePlatform?: () => boolean } })
    .Capacitor;
  if (cap?.isNativePlatform) {
    try {
      return cap.isNativePlatform();
    } catch {
      /* fall through to UA sniff */
    }
  }
  // UA fallback — WKWebView in the Capacitor shell.
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  return (
    ua.includes("Capacitor") ||
    (typeof window !== "undefined" &&
      ["capacitor://", "ionic://", "https://localhost"].some((p) =>
        window.location.href.startsWith(p),
      ))
  );
}

@Injectable({ providedIn: "root" })
export class PlatformService {
  readonly isNative = isNativePlatform();
}
